function SlotModel(BaseModel, SlotService) {
    'ngInject';

    class Slot extends BaseModel {

        constructor(data) {
            super(data);
            this.datetime = moment(data.datetime);
        }

        static $query(company, params) {
            return SlotService.query(company, params);
        }
    }

    return Slot;
}

/***
 * @ngdoc service
 * @name BB:Slot
 *
 * @description
 * Representation of an Slot Object
 *
 * @property {integer} total_entries The The total entries of the slot
 * @property {array} slots An array with slots
 */
angular
    .module('BB')
    .service('SlotModel', SlotModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/slot_model.service.js